import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import {
  Grid,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  Checkbox,
  Box,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import api from "_api";
import "assets/css/modal.css";
import { Flex } from "antd";

const ModalAddDate = ({
  open,
  onClose,
  companyId,
  package_type_id,
  company_package_id,
  fetchProductData,
  setPackageTypeActive,
}) => {
  const validationSchema = Yup.object({
    date: Yup.number()
      .moreThan(0, "จำนวนวันต้องมากกว่า 0")
      .required("โปรดระบุจำนวนวัน"),
  });

  const formik = useFormik({
    initialValues: {
      date: 0,
    },
    validationSchema: validationSchema,

    onSubmit: async (values, { resetForm }) => {
      const addDateData = {
        date: values.date,
        company_id: companyId,
        package_id: package_type_id,
      };
      try {
        const response = await api.super_admin.addDateCompanyPackage(
          company_package_id,
          addDateData
        );

        if (response.isStatus) {
          resetForm();
          onClose();
          fetchProductData();
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        alert(`Error submitting form: ${error.message}`);
      }
    },
  });

  const handleCancel = () => {
    setPackageTypeActive(null);
    onClose();
    formik.resetForm();
  };
  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
      sx={{
        borderRadius: "8px",
      }}
    >
      <DialogTitle sx={{ padding: "24px 80px 24px 24px" }}>
        เพิ่มระยะเวลาทดลองการใช้งานการใช้งาน
      </DialogTitle>
      <DialogContent sx={{ padding: 3 }}>
        <form onSubmit={formik.handleSubmit}>
          <Flex gap={10} align="center">
            <TextField
              id="date"
              name="date"
              type="number"
              value={formik.values["date"]}
              onChange={formik.handleChange}
              {...formik.getFieldProps("date")}
              error={formik.touched["date"] && Boolean(formik.errors["date"])}
              helperText={formik.touched["date"] && formik.errors["date"]}
              fullWidth
              InputProps={{
                sx: { height: "40px" },
                inputProps: {
                  style: {
                    "-moz-appearance": "textfield", // Hide up/down arrows in Firefox
                    "-webkit-appearance": "none", // Hide up/down arrows in Chrome/Safari
                    appearance: "none", // Hide up/down arrows in other browsers
                  },
                  maxLength: 3,
                  inputMode: "numeric",
                  pattern: "[0-9]*", // Restrict input to numbers
                },
              }}
            />
            วัน
          </Flex>
        </form>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <GradientButtonOutline
          variant="outlined"
          sx={{ mr: 1 }}
          onClick={handleCancel}
        >
          ยกเลิก
        </GradientButtonOutline>
        <GradientButton
          variant="contained"
          onClick={formik.handleSubmit}
          type="submit"
        >
          บันทึก
        </GradientButton>
      </DialogActions>
    </Dialog>
  );
};

export default ModalAddDate;
